__turbopack_context__.v({
  "gift-button": "gift-this-course-module-scss-module__KJRDlG__gift-button",
});
